import React from 'react';
import Style from './EOV_OV.module.css';
import Button from '@mui/material/Button';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {useParams} from "react-router-dom";


export default function Menu() {
    const { i18n, t } = useTranslation();

  let { id } = useParams<{id:string}>();
  //console.log(id);

  return(
    <React.Fragment>
      <NavLink to={'/DDTS/EOV_OV/' + id }  className={({isActive}) => isActive ? Style.Button_Active : undefined}>
        <Button variant="contained" color="secondary" >
          {t("switchboard")}
        </Button>
      </NavLink>
      <NavLink to={'/DDTS/EOV_OV/' + id + '/CVA'} className={({isActive}) => isActive ? Style.Button_Active : undefined}>
        <Button variant="contained" color="secondary" >
          CVA {t("modules")}
        </Button>
      </NavLink>
      <NavLink to={'/DDTS/EOV_OV/' + id + '/outputs'} className={({isActive}) => isActive ? Style.Button_Active : undefined}>
        <Button variant="contained" color="secondary" >
          {t("outputs")}
        </Button>
      </NavLink>
      <NavLink to={'/DDTS/EOV_OV/' + id + '/io'} className={({isActive}) => isActive ? Style.Button_Active : undefined}>
        <Button variant="contained" color="secondary" >
          I/O
        </Button>
      </NavLink>
    </React.Fragment>
  )
}